import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import IApplication from '~Api/Application/IApplication';
import IBorrower from '~Api/Application/IBorrower';
import ConditionDocumentApprovalStatusEnum from '~Api/Application/ConditionDocumentApprovalStatusEnum';
import ConditionTypeEnum from '~Api/Application/ConditionTypeEnum';
import IConditionDocument from '~Api/Application/IConditionDocument';
import { applicationConditionDocumentsAddAction } from '~Applications/actions';
import IApplicationProperty from '~Api/Application/IApplicationProperty';

interface IProps {
    application: IApplication;
    applicationBorrower?: IBorrower;
    applicationProperty?: IApplicationProperty;
    conditionType?: ConditionTypeEnum;
    conditionUuid?: string;
}

interface IPropsDispatch {
    applicationConditionDocumentsAdd: (file: File, conditionDocument: IConditionDocument) => void;
}

type Props = IProps & IPropsDispatch;

class UploadConditionDocument extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.beforeUpload = this.beforeUpload.bind(this);
    }

    public render(): JSX.Element {
        return (
            <Upload className='add-document' beforeUpload={this.beforeUpload} showUploadList={false}>
                <Button type='link'><UploadOutlined/></Button>
            </Upload>
        );
    }

    private beforeUpload(file: File): boolean {
        const {
            application,
            applicationBorrower,
            conditionUuid,
            conditionType,
            applicationProperty,
        } = this.props;

        const conditionDocument: IConditionDocument = {
            approvalStatus: ConditionDocumentApprovalStatusEnum.Pending,
            conditionType,
            conditionUuid,
        };

        if (applicationBorrower) {
            conditionDocument.applicationBorrowerUuid = applicationBorrower.uuid;
        }else if (applicationProperty) {
            conditionDocument.applicationPropertyUuid = applicationProperty.uuid;
        } else {
            conditionDocument.applicationUuid = application.uuid;
        }

        this.props.applicationConditionDocumentsAdd(file, conditionDocument);

        return false;
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        applicationConditionDocumentsAdd: (file: File, conditionDocument: IConditionDocument) => dispatch(applicationConditionDocumentsAddAction(ownProps.application.uuid, file, conditionDocument)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(UploadConditionDocument);
